import React from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { Modal } from '@components';

const CertModal = ({ msg }) => {
    const {
        LoanStore: { certModalVisible, closeCertModal },
    } = useStore();
    // todo 新增顯示全景錯誤訊息msg
    return (
        <Modal
            show={certModalVisible}
            onHide={closeCertModal}
            title={'簽驗錯誤'}
        >
            <div>
                <div className="border-0">
                    <div className="icon_fast mx-auto "></div>
                    <div className="icon_info mx-auto mb-3"></div>
                    {msg}
                    <div className="btn_box d-flex flex-column-reverse flex-sm-row justify-content-center">
                        <button
                            className="btn_check btn rounded-pill text-white"
                            type="button"
                            onClick={() => {
                                closeCertModal();
                            }}
                        >
                            確認
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
export default observer(CertModal);
